import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';
import { DialogTrigger } from '@raydiant/raydial/components/Dialog';
import Popover from '@raydiant/raydial/components/Popover';
import { Plus } from '../../../../LocationsPage/Icons';

interface LibraryPageActionButtonProps {
  isOpen: boolean;
  isDisabled?: boolean;
  buttonLabel?: string;
  isSharedLibraryTopLevel?: boolean;
  onClick: (open: boolean) => void;
  onFolderClick: () => void;
  onPresentationClick: () => void;
  onPlaylistClick: () => void;
}

const LibraryPageActionButton = ({
  isOpen,
  isDisabled = false,
  buttonLabel = 'Presentation',
  isSharedLibraryTopLevel = false,
  onClick,
  onFolderClick,
  onPresentationClick,
  onPlaylistClick,
}: LibraryPageActionButtonProps) => {
  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onClick}>
      <Button
        className="w-[156px] h-14 px-4 py-5 rounded-2xl bg-blue-600 disabled:bg-gray-600"
        aria-label="add"
        variant="primary"
        isDisabled={isDisabled}
        onPress={() => onClick(true)}
      >
        <div className="flex text-white items-center">
          <Plus />
          <Text className="normal-case ml-2.5" variant="largeSubtitle">
            Add
          </Text>
        </div>
      </Button>
      <Popover className="w-[156px] py-2" offset={2}>
        <button
          className="flex items-center text-lg font-regular h-9 px-2.5 py-4 w-full hover:bg-gray-100 "
          onClick={() => onPresentationClick()}
        >
          {buttonLabel}
        </button>
        {/* At shared libraries top level only expose the primary action; Folder and Playlist are not applicable here */}
        {!isSharedLibraryTopLevel && (
          <>
            <button
              className="flex items-center text-lg font-regular h-9 px-2.5 py-4 w-full hover:bg-gray-100 "
              onClick={() => onFolderClick()}
            >
              Folder
            </button>
            <button
              className="flex items-center text-lg font-regular h-9 px-2.5 py-4 w-full hover:bg-gray-100 "
              onClick={() => onPlaylistClick()}
            >
              Playlist
            </button>
          </>
        )}
      </Popover>
    </DialogTrigger>
  );
};

export default LibraryPageActionButton;
